import axios from "@/libs/api.request";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/warehouse/airpacking",
    params,
    method: "get"
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/warehouse/airpacking",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = params => {
  return axios.request({
    url: `/warehouse/airpacking/${params.id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/warehouse/airpacking/${data.packing_id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = data => {
  return axios.request({
    url: `/warehouse/airpacking/${data.id}`,
    method: "DELETE"
  });
};

// 获取出库入库列表
export const getOutInList = params => {
  return axios.request({
    url: `/warehouse/airpacking/bound/${params.id}`,
    method: "get",
    params
  });
};

// 出入库提交
export const outInSubmit = data => {
  return axios.request({
    url: `/warehouse/airpacking/operator/${data.packing_id}`,
    method: "post",
    data
  });
};

// 出入库提交
export const setTime = data => {
  return axios.request({
    url: `/warehouse/airpacking/setTime/${data.id}`,
    method: "post",
    data
  });
};
